import { useMemo } from 'react';

import PreviewFwdCurveChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewFwdCurveChart';
import PreviewSeasonalChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewSeasonalChart';
import PreviewSpotChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewSpotChart';
import { useExportMeta } from '@/features/DataHub/modules/Export/context/ExportMetaContext';
import { useAppSelector } from '@/hooks/redux-hooks';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';
import PreviewFullscreenChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewFullscreenChart';

const Preview = ({ showLegend = true }: { showLegend?: boolean }) => {
  const { type: exportType, from, isLightMode } = useAppSelector(state => state.export);
  const { uniqueSymbols } = useExportMeta();
  const symbols = useMemo(() => Array.from(uniqueSymbols), [uniqueSymbols]);
  if (!exportType || exportType === ExportTypes.DATA) {
    return (
      <PreviewSpotChart
        symbols={symbols}
        showLegend={showLegend}
      />
    );
  }
  if (exportType === 'fullscreen') {
    return (
      <PreviewFullscreenChart
        symbols={symbols}
        showLegend={showLegend}
        isLightMode={isLightMode}
      />
    );
  }
  if (exportType === 'spot') {
    return (
      <PreviewSpotChart
        symbols={symbols}
        showLegend={showLegend}
      />
    );
  }
  if (exportType === 'forwardSimple') {
    return <PreviewFwdCurveChart symbols={symbols} />;
  }
  if (exportType === 'seasonal') {
    return (
      <PreviewSeasonalChart
        from={from}
        symbols={symbols}
      />
    );
  }
  return null;
};
export default Preview;
